<template>
  <div class="esports-container" :class="{ 'mobile': isMobile }">
    <EsportsIframe
      ref="esportsIframe"
      :brandToken="brandToken"
      :baseUrl="baseUrl"
      :token="userToken"
      :language="language"
      :currency="currency"
      :theme="theme"
      :darkMode="darkMode"
      :oddsFormat="oddsFormat"
      :banners="banners"
      :customCurrencySymbols="customCurrencySymbols"
      :showHeader="false"
      @request-sign-in="handleSignIn"
      @request-refresh-balance="handleRefreshBalance"
      @analytics="handleAnalytics"
      @error="handleError"
      @loaded="handleLoaded"
      @route-change="handleRouteChange"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import EsportsIframe from './EsportsIframe.vue';

export default {
  name: "FullaEsports",
  components: {
    EsportsIframe,
  },
  data() {
    return {
      // Fulla.bet 설정
      brandToken: 'e4ffdf5e-fb51-4fdd-aef7-a937620888c6',
      baseUrl: process.env.NODE_ENV === 'development' 
        ? 'https://iframe.fulla.bet' 
        : 'https://iframe.integration.fulla.bet',
      language: 'ko',
      currency: 'KRW',
      theme: null,
      darkMode: true,
      oddsFormat: 'DECIMAL',
      
      // 보안 및 도메인 검증 설정
      // referer: window.location.origin (자동으로 EsportsIframe에서 설정됨)
      // - Fulla.bet의 도메인 화이트리스트 검증을 위해 필요
      // - 현재 사이트의 도메인을 자동으로 전달
      
      // 배너 설정
      banners: {
        timeline: {
          items: [
            // { type: 'IFRAME', src: 'https://your-adserver.example/slot' },
            // { type: 'IMAGE', src: 'https://cdn.example/banner.png', link: 'https://example.com/promo' },
          ],
        },
      },
      
      // 통화 심볼 설정
      customCurrencySymbols: [
        { currency: 'KRW', right: '원' },
      ],
    }
  },
  computed: {
    ...mapState({
      user: state => state.user.user,
    }),
    userToken() {
      // 토큰 유효성 검사
      const token = localStorage.getItem('authToken');

      // 토큰이 없거나 빈 문자열이면 null 반환 (로그아웃 모드)
      if (!token || token.trim() === '') {
        return null;
      }
      
      // JWT 토큰 형식 검증 (간단한 검증)
      if (!token.includes('.') || token.split('.').length !== 3) {
        console.warn('⚠️ 잘못된 JWT 토큰 형식:', token);
        return null;
      }
      
      return token;
    },
    isMobile() {
      return this.$store.state.page.isMobile;
    }
  },
  // watch: {
  //   user: {
  //     handler(newVal) {
  //       if (newVal) {
  //         console.log('User updated:', newVal);
  //         this.$refs.esportsIframe.reload();
  //       }
  //     },
  //     immediate: true
  //   }
  // },
  methods: {
    handleSignIn() {
      console.log('Sign in requested');
      this.$router.push('/login');
    },
    
    handleRefreshBalance() {
      console.log('Balance refresh requested');
      // TODO: 실제 잔액 갱신 API 호출
      // this.$store.dispatch('user/refreshBalance');
    },
    
    handleAnalytics(event) {
      console.log('Analytics event:', event);
      
      let payload;
      
      // payload가 이미 객체인지 문자열인지 확인
      if (typeof event.payload === 'string') {
        try {
          payload = JSON.parse(event.payload);
        } catch (e) {
          console.error('Analytics payload parsing error:', e);
          payload = {};
        }
      } else if (typeof event.payload === 'object' && event.payload !== null) {
        // 이미 객체인 경우
        payload = event.payload;
      } else {
        // payload가 없거나 null인 경우
        payload = {};
      }
      
      console.log('Analytics payload:', payload);
      
      // TODO: 실제 분석 이벤트 전송
      // this.$analytics.track(event.action, payload);
    },
    
    handleError(error) {
      console.error('❌ Fulla iFrame 에러:', error);
      
      // 도메인 화이트리스트 체크
      if (error?.message?.includes('blocked')) {
        console.error('❌ 도메인 화이트리스트 문제: Fulla 측에 현재 도메인 등록 필요');
        console.error('현재 도메인:', window.location.origin);
      }
      
      // 사용자에게 에러 메시지 표시
      this.$alert({
        title: 'Esports 로딩 오류',
        message: `Esports 로딩 중 오류가 발생했습니다.\n\n개발자 도구(F12) → Console 탭에서 상세 로그를 확인해주세요.\n\n에러: ${error.message || 'Unknown error'}`,
        type: 'error'
      });
    },
    
    handleLoaded() {
      console.log('Fulla iFrame loaded successfully');
    },
    
    handleRouteChange(route) {
      console.log('Route changed in iFrame:', route);
    },
  }
}
</script>

<style scoped>
.esports-container {
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
}

.esports-container.mobile {
  /* 모바일 특별 스타일 */
}
</style>
